import { render, staticRenderFns } from "./ConsultarRequisicoesForm.vue?vue&type=template&id=c177ba30&scoped=true"
import script from "./ConsultarRequisicoesForm.vue?vue&type=script&lang=js"
export * from "./ConsultarRequisicoesForm.vue?vue&type=script&lang=js"
import style0 from "./ConsultarRequisicoesForm.vue?vue&type=style&index=0&id=c177ba30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c177ba30",
  null
  
)

export default component.exports